var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUartDataType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 179.97 127.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #6fccdd;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #97d3bb;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.99,0H17.99c-3.89,0-7.03,3.15-7.03,7.04v83.63c0,3.89,3.14,7.04,7.03,7.04h144c3.88,0,7.03-3.15,7.03-7.04V7.04c0-3.89-3.15-7.04-7.03-7.04ZM164.44,87.84c0,3.88-3.15,7.03-7.04,7.03H22.58c-3.89,0-7.04-3.15-7.04-7.03V9.87c0-3.88,3.15-7.03,7.04-7.03h134.82c3.89,0,7.04,3.15,7.04,7.03v77.97Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "179.97 120.68 0 120.68 10.83 99.99 169.14 99.99 179.97 120.68"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.21,30.36h-15.15c5.82-5.83,9.14-9.14,15.02-15.02h.13v15.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.02,15.34v16.83h-17.14v50.2h48.82V15.34h-31.68ZM77.84,66.82h-35.1c-.78,0-1.42-.63-1.42-1.41s.64-1.42,1.42-1.42h35.1c.78,0,1.42.64,1.42,1.42s-.64,1.41-1.42,1.41ZM77.84,59.72h-35.1c-.78,0-1.42-.64-1.42-1.42s.64-1.41,1.42-1.41h35.1c.78,0,1.42.63,1.42,1.41s-.64,1.42-1.42,1.42ZM77.84,52.61h-35.1c-.78,0-1.42-.63-1.42-1.41s.64-1.41,1.42-1.41h35.1c.78,0,1.42.63,1.42,1.41s-.64,1.41-1.42,1.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 100.16,
    cy: 21.61,
    r: 3.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 100.16,
    cy: 32.51,
    r: 3.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 100.16,
    cy: 43.41,
    r: 3.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 100.16,
    cy: 54.3,
    r: 3.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 100.16,
    cy: 65.2,
    r: 3.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 100.16,
    cy: 76.1,
    r: 3.24
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 108.91,
    y: 20.2,
    width: 35.17,
    height: 2.82,
    rx: 1.41,
    ry: 1.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 108.91,
    y: 31.1,
    width: 35.17,
    height: 2.82,
    rx: 1.41,
    ry: 1.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 108.91,
    y: 42,
    width: 35.17,
    height: 2.82,
    rx: 1.41,
    ry: 1.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 108.91,
    y: 52.89,
    width: 35.17,
    height: 2.82,
    rx: 1.41,
    ry: 1.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 108.91,
    y: 63.79,
    width: 35.17,
    height: 2.82,
    rx: 1.41,
    ry: 1.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 108.91,
    y: 74.69,
    width: 35.17,
    height: 2.82,
    rx: 1.41,
    ry: 1.41
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,120.68h179.97v1.75c0,2.98-2.42,5.4-5.4,5.4H5.4c-2.98,0-5.4-2.42-5.4-5.4v-1.75h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "98.32 118.45 81.65 118.45 84.75 114.93 95.22 114.93 98.32 118.45"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "44.83 103.84 41.11 103.84 41.81 102.22 44.14 102.22 44.83 103.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "48.75 103.84 45.03 103.84 45.72 102.22 48.06 102.22 48.75 103.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "52.67 103.84 48.95 103.84 49.64 102.22 51.98 102.22 52.67 103.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "56.59 103.84 52.87 103.84 53.56 102.22 55.9 102.22 56.59 103.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "60.5 103.84 56.78 103.84 57.48 102.22 59.81 102.22 60.5 103.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "64.42 103.84 60.7 103.84 61.39 102.22 63.73 102.22 64.42 103.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "68.34 103.84 64.62 103.84 65.31 102.22 67.65 102.22 68.34 103.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "72.26 103.84 68.54 103.84 69.23 102.22 71.57 102.22 72.26 103.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "76.18 103.84 72.45 103.84 73.15 102.22 75.48 102.22 76.18 103.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "80.09 103.84 76.37 103.84 77.06 102.22 79.4 102.22 80.09 103.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "84.01 103.84 80.29 103.84 80.98 102.22 83.32 102.22 84.01 103.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "87.93 103.84 84.21 103.84 84.9 102.22 87.24 102.22 87.93 103.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "91.85 103.84 88.13 103.84 88.82 102.22 91.15 102.22 91.85 103.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "95.76 103.84 92.04 103.84 92.73 102.22 95.07 102.22 95.76 103.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "99.68 103.84 95.96 103.84 96.65 102.22 98.99 102.22 99.68 103.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "103.6 103.84 99.88 103.84 100.57 102.22 102.91 102.22 103.6 103.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "107.52 103.84 103.8 103.84 104.49 102.22 106.82 102.22 107.52 103.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "111.43 103.84 107.71 103.84 108.41 102.22 110.74 102.22 111.43 103.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "115.35 103.84 111.63 103.84 112.32 102.22 114.66 102.22 115.35 103.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "119.27 103.84 115.55 103.84 116.24 102.22 118.58 102.22 119.27 103.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "123.19 103.84 119.47 103.84 120.16 102.22 122.5 102.22 123.19 103.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "127.1 103.84 123.38 103.84 124.08 102.22 126.41 102.22 127.1 103.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "131.02 103.84 127.3 103.84 127.99 102.22 130.33 102.22 131.02 103.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "134.94 103.84 131.22 103.84 131.91 102.22 134.25 102.22 134.94 103.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.86 103.84 135.14 103.84 135.83 102.22 138.17 102.22 138.86 103.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "44.83 106.23 41.11 106.23 41.81 104.61 44.14 104.61 44.83 106.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "48.75 106.23 45.03 106.23 45.72 104.61 48.06 104.61 48.75 106.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "52.67 106.23 48.95 106.23 49.64 104.61 51.98 104.61 52.67 106.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "56.59 106.23 52.87 106.23 53.56 104.61 55.9 104.61 56.59 106.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "60.5 106.23 56.78 106.23 57.48 104.61 59.81 104.61 60.5 106.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "64.42 106.23 60.7 106.23 61.39 104.61 63.73 104.61 64.42 106.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "68.34 106.23 64.62 106.23 65.31 104.61 67.65 104.61 68.34 106.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "72.26 106.23 68.54 106.23 69.23 104.61 71.57 104.61 72.26 106.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "76.18 106.23 72.45 106.23 73.15 104.61 75.48 104.61 76.18 106.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "80.09 106.23 76.37 106.23 77.06 104.61 79.4 104.61 80.09 106.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "84.01 106.23 80.29 106.23 80.98 104.61 83.32 104.61 84.01 106.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "87.93 106.23 84.21 106.23 84.9 104.61 87.24 104.61 87.93 106.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "91.85 106.23 88.13 106.23 88.82 104.61 91.15 104.61 91.85 106.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "95.76 106.23 92.04 106.23 92.73 104.61 95.07 104.61 95.76 106.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "99.68 106.23 95.96 106.23 96.65 104.61 98.99 104.61 99.68 106.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "103.6 106.23 99.88 106.23 100.57 104.61 102.91 104.61 103.6 106.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "107.52 106.23 103.8 106.23 104.49 104.61 106.82 104.61 107.52 106.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "111.43 106.23 107.71 106.23 108.41 104.61 110.74 104.61 111.43 106.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "115.35 106.23 111.63 106.23 112.32 104.61 114.66 104.61 115.35 106.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "119.27 106.23 115.55 106.23 116.24 104.61 118.58 104.61 119.27 106.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "123.19 106.23 119.47 106.23 120.16 104.61 122.5 104.61 123.19 106.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "127.1 106.23 123.38 106.23 124.08 104.61 126.41 104.61 127.1 106.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "131.02 106.23 127.3 106.23 127.99 104.61 130.33 104.61 131.02 106.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "134.94 106.23 131.22 106.23 131.91 104.61 134.25 104.61 134.94 106.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.86 106.23 135.14 106.23 135.83 104.61 138.17 104.61 138.86 106.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "44.83 108.63 41.11 108.63 41.81 107 44.14 107 44.83 108.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "48.75 108.63 45.03 108.63 45.72 107 48.06 107 48.75 108.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "52.67 108.63 48.95 108.63 49.64 107 51.98 107 52.67 108.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "56.59 108.63 52.87 108.63 53.56 107 55.9 107 56.59 108.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "60.5 108.63 56.78 108.63 57.48 107 59.81 107 60.5 108.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "64.42 108.63 60.7 108.63 61.39 107 63.73 107 64.42 108.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "68.34 108.63 64.62 108.63 65.31 107 67.65 107 68.34 108.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "72.26 108.63 68.54 108.63 69.23 107 71.57 107 72.26 108.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "76.18 108.63 72.45 108.63 73.15 107 75.48 107 76.18 108.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "80.09 108.63 76.37 108.63 77.06 107 79.4 107 80.09 108.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "84.01 108.63 80.29 108.63 80.98 107 83.32 107 84.01 108.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "87.93 108.63 84.21 108.63 84.9 107 87.24 107 87.93 108.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "91.85 108.63 88.13 108.63 88.82 107 91.15 107 91.85 108.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "95.76 108.63 92.04 108.63 92.73 107 95.07 107 95.76 108.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "99.68 108.63 95.96 108.63 96.65 107 98.99 107 99.68 108.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "103.6 108.63 99.88 108.63 100.57 107 102.91 107 103.6 108.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "107.52 108.63 103.8 108.63 104.49 107 106.82 107 107.52 108.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "111.43 108.63 107.71 108.63 108.41 107 110.74 107 111.43 108.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "115.35 108.63 111.63 108.63 112.32 107 114.66 107 115.35 108.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "119.27 108.63 115.55 108.63 116.24 107 118.58 107 119.27 108.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "123.19 108.63 119.47 108.63 120.16 107 122.5 107 123.19 108.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "127.1 108.63 123.38 108.63 124.08 107 126.41 107 127.1 108.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "131.02 108.63 127.3 108.63 127.99 107 130.33 107 131.02 108.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "134.94 108.63 131.22 108.63 131.91 107 134.25 107 134.94 108.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.86 108.63 135.14 108.63 135.83 107 138.17 107 138.86 108.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "44.83 111.02 41.11 111.02 41.81 109.39 44.14 109.39 44.83 111.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "48.75 111.02 45.03 111.02 45.72 109.39 48.06 109.39 48.75 111.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "52.67 111.02 48.95 111.02 49.64 109.39 51.98 109.39 52.67 111.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "56.59 111.02 52.87 111.02 53.56 109.39 55.9 109.39 56.59 111.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "60.5 111.02 56.78 111.02 57.48 109.39 59.81 109.39 60.5 111.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "64.42 111.02 60.7 111.02 61.39 109.39 63.73 109.39 64.42 111.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "68.34 111.02 64.62 111.02 65.31 109.39 67.65 109.39 68.34 111.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "72.26 111.02 68.54 111.02 69.23 109.39 71.57 109.39 72.26 111.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "76.18 111.02 72.45 111.02 73.15 109.39 75.48 109.39 76.18 111.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "80.09 111.02 76.37 111.02 77.06 109.39 79.4 109.39 80.09 111.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "84.01 111.02 80.29 111.02 80.98 109.39 83.32 109.39 84.01 111.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "87.93 111.02 84.21 111.02 84.9 109.39 87.24 109.39 87.93 111.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "91.85 111.02 88.13 111.02 88.82 109.39 91.15 109.39 91.85 111.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "95.76 111.02 92.04 111.02 92.73 109.39 95.07 109.39 95.76 111.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "99.68 111.02 95.96 111.02 96.65 109.39 98.99 109.39 99.68 111.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "103.6 111.02 99.88 111.02 100.57 109.39 102.91 109.39 103.6 111.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "107.52 111.02 103.8 111.02 104.49 109.39 106.82 109.39 107.52 111.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "111.43 111.02 107.71 111.02 108.41 109.39 110.74 109.39 111.43 111.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "115.35 111.02 111.63 111.02 112.32 109.39 114.66 109.39 115.35 111.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "119.27 111.02 115.55 111.02 116.24 109.39 118.58 109.39 119.27 111.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "123.19 111.02 119.47 111.02 120.16 109.39 122.5 109.39 123.19 111.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "127.1 111.02 123.38 111.02 124.08 109.39 126.41 109.39 127.1 111.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "131.02 111.02 127.3 111.02 127.99 109.39 130.33 109.39 131.02 111.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "134.94 111.02 131.22 111.02 131.91 109.39 134.25 109.39 134.94 111.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.86 111.02 135.14 111.02 135.83 109.39 138.17 109.39 138.86 111.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "44.83 113.41 41.11 113.41 41.81 111.78 44.14 111.78 44.83 113.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "48.75 113.41 45.03 113.41 45.72 111.78 48.06 111.78 48.75 113.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "52.67 113.41 48.95 113.41 49.64 111.78 51.98 111.78 52.67 113.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "56.59 113.41 52.87 113.41 53.56 111.78 55.9 111.78 56.59 113.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "60.5 113.41 56.78 113.41 57.48 111.78 59.81 111.78 60.5 113.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "64.42 113.41 60.7 113.41 61.39 111.78 63.73 111.78 64.42 113.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "68.34 113.41 64.62 113.41 65.31 111.78 67.65 111.78 68.34 113.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "72.26 113.41 68.54 113.41 69.23 111.78 71.57 111.78 72.26 113.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "76.18 113.41 72.45 113.41 73.15 111.78 75.48 111.78 76.18 113.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "80.09 113.41 76.37 113.41 77.06 111.78 79.4 111.78 80.09 113.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "84.01 113.41 80.29 113.41 80.98 111.78 83.32 111.78 84.01 113.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "87.93 113.41 84.21 113.41 84.9 111.78 87.24 111.78 87.93 113.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "91.85 113.41 88.13 113.41 88.82 111.78 91.15 111.78 91.85 113.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "95.76 113.41 92.04 113.41 92.73 111.78 95.07 111.78 95.76 113.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "99.68 113.41 95.96 113.41 96.65 111.78 98.99 111.78 99.68 113.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "103.6 113.41 99.88 113.41 100.57 111.78 102.91 111.78 103.6 113.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "107.52 113.41 103.8 113.41 104.49 111.78 106.82 111.78 107.52 113.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "111.43 113.41 107.71 113.41 108.41 111.78 110.74 111.78 111.43 113.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "115.35 113.41 111.63 113.41 112.32 111.78 114.66 111.78 115.35 113.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "119.27 113.41 115.55 113.41 116.24 111.78 118.58 111.78 119.27 113.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "123.19 113.41 119.47 113.41 120.16 111.78 122.5 111.78 123.19 113.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "127.1 113.41 123.38 113.41 124.08 111.78 126.41 111.78 127.1 113.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "131.02 113.41 127.3 113.41 127.99 111.78 130.33 111.78 131.02 113.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "134.94 113.41 131.22 113.41 131.91 111.78 134.25 111.78 134.94 113.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.86 113.41 135.14 113.41 135.83 111.78 138.17 111.78 138.86 113.41"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUartDataType);
export default __webpack_public_path__ + "static/media/uart-data-type.8629aae22776c521d0715706c2b2e1f0.svg";
export { ForwardRef as ReactComponent };